module.exports = __webpack_public_path__ + "img/nuxt-dot-js-3521615-2945059.55851264.png";